/**
 * MODULES - reCAPTCHA Enterprise (score-based)
 * Ładuje skrypt z 2s opóźnieniem, generuje token w tle i wstrzykuje
 * go do ukrytego pola formularza. Token odświeżany co 90s (wygasa po 2 min).
 */

const recaptchaDelay = (() => {
  const SITE_KEY = '6LeeHOssAAAAABnF3YngwZXux3E-mYNwhGPEn21z';
  const ACTION = 'form_contact';
  let tokenInputs = [];

  const init = () => {
    if (!document.querySelector('[data-validation-form]')) return;
    setTimeout(appendScript, 2000);
  };

  const appendScript = () => {
    if (document.querySelector('script[src*="recaptcha/enterprise.js"]')) return;

    // Wstrzyknij ukryte pole g-recaptcha-response do każdego formularza
    document.querySelectorAll('[data-validation-form]').forEach((form) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'g-recaptcha-response';
      input.setAttribute('aria-hidden', 'true');
      form.appendChild(input);
      tokenInputs.push(input);
    });

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`;
    script.async = true;
    script.onload = refreshToken;
    document.body.appendChild(script);
  };

  const refreshToken = () => {
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise
        .execute(SITE_KEY, { action: ACTION })
        .then((token) => {
          tokenInputs.forEach((input) => (input.value = token));
        })
        .catch((e) => {
          console.warn('reCAPTCHA token error:', e);
        });
    });
  };

  // Token wygasa po 2 min — odświeżaj co 90s
  setInterval(() => {
    if (tokenInputs.length) refreshToken();
  }, 90000);

  return { init };
})();

export { recaptchaDelay };
